/**
 * @desc 发送邮件
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(body: defs.mail.MailMessageDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/message/send`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
